import { render } from "./vehicles.vue?vue&type=template&id=f97f1542"
import script from "./vehicles.vue?vue&type=script&lang=js"
export * from "./vehicles.vue?vue&type=script&lang=js"

import "./vehicles.vue?vue&type=style&index=0&id=f97f1542&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__